import React from 'react';
import { useResponsive, useTranslation } from 'client/hooks';
import { ControlPanel, Header } from 'client/components/common/mobile';
import { HelmetComponent } from 'client/components/common';
import { staticPages as staticPagesApi } from 'client/redux/api/static-pages';
import { TARGET_VALUES } from 'models/other/interface';
import css from './TermsOfUse.module.scss';
import rtCSS from 'src/routes/client/styles/RichTextContent.module.scss';

const TermsOfUse = () => {
  const [isMobile] = useResponsive(['MOBILE']);
  const { translate } = useTranslation();
  const { data, isFetching } = staticPagesApi.endpoints.getStaticPage.useQuery({ target: TARGET_VALUES.TERMS_OF_USE });
  const pageData = data?.success && data.data ? data.data : { title: '', body: '' };

  return (
    <>
      <HelmetComponent
        title={translate('seo.terms.title')}
        description={translate('seo.terms.description')}
        ogTitle={translate('seo.terms.title')}
        ogDescription={translate('seo.terms.description')}
      ></HelmetComponent>
      <div className={css.pageWrapper}>
        {isMobile ? <Header className={css.pageHeader} /> : null}
        {isMobile ? <ControlPanel className={css.controlPanel} /> : null}

        {pageData && (
          <div className={css.contentWrapper}>
            <div className={rtCSS.title}>{pageData?.title}</div>
            <div className={rtCSS.richTextContent} dangerouslySetInnerHTML={{ __html: pageData.body }}></div>
          </div>
        )}
      </div>
    </>
  );
};

export default TermsOfUse;
